export class ValidatedChargeNumber {
  id: number;
  chargeNumber: string;
  exists: boolean;
}
